import { render, staticRenderFns } from "./BaseSidebarLink.vue?vue&type=template&id=3fca1016&"
import script from "./BaseSidebarLink.vue?vue&type=script&lang=js&"
export * from "./BaseSidebarLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports